<template>
	<div class="create-container peering-create-container">
		<div class="create-host">
			<div class="jc-page-header">
				<div class="jc-container">
					<el-page-header show-back-icon
						:title="$t('peering.text.connection')"
						@back="goToList">
						<template slot="content">
							<div class="jc-list__header--right">
								<a :href="Config.BUY_HELP_URL" target="_blank" class="fr buy-info">
									{{$t('create.text.buyMustKnow')}}
								</a>
							</div>
						</template>
					</el-page-header>
				</div>
			</div>
			<div class="jc-page-content">
				<div class="jc-container pr">
					<div class="buildTab">
						<ul>
							<li id="tab1" @click="setTab('tab',1,2)" class="hover">
								{{$t('create.text.byConfigurations')}}
							</li>
						</ul>
					</div>
					<div class="buildCon" id="con-tab-1">
						<div class="infoBox">
							<!-- 本端信息 -->
							<div class="jc-page-card">
								<div class="jc-page-card-header">
									<h3 class="jc-page-card-title">{{$t("peering.text.localTerminalInfo")}}</h3>
								</div>
								<el-form class="jc-form cps-create-form" label-width="130px"
									:model="localTerminalInfo"
									id="localTerminalInfoForm"
									ref="localTerminalInfoForm" :rules="localTerminalInfoRules">
									<!--名称-->
									<el-form-item
										:label="$t('peering.text.name') | withColon"
										prop="name"
										:show-message="false" required
										ref="name">
										<el-input
											v-model="localTerminalInfo.name"></el-input>
										<el-tooltip class="ml10" effect="dark" placement="right">
											<div slot="content" class="my-os-disk-tip">
												{{$t('peering.tooltip.name')}}
											</div>
											<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
										<p v-if="ruleFormTag.name === 'empty' "
											class="jc-form-item-help-error">
											{{$t('create.placeholder.nameNull')}}</p>
										<p v-else class="jc-form-item-help"
											:class="{'jc-form-item-help-error': ruleFormTag.name == 'error'}">
											{{$t('create.help.instanceNameRule1')}}</p>
									</el-form-item>
									<!-- 本端地域 -->
									<el-form-item :label="$t('peering.text.localRegion') | withColon">
										<el-select v-model="localTerminalInfo.region"
											@change="(val) => regionChange(val, 'localTerminalInfo')">
											<el-option v-for="(regionName,region,index) in peerRegions"
												:key="index"
												:label="regionName"
												:value="region">
											</el-option>
										</el-select>
										<el-tooltip effect="dark" class="ml10" placement="right">
											<div slot="content" class="my-os-disk-tip">{{$t('peering.tooltip.region')}}
											</div>
											<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
									</el-form-item>
									<!-- 本端私有网络 -->
									<el-form-item :label="$t('peering.text.localVpc')| withColon"
										class="net-select" prop="vpcId" ref="vpcId">
										<el-select v-model="localTerminalInfo.vpcId" class="select-vpc"
											:loading="localTerminalInfo.vpcLoading"
											@change="(id)=>vpcChange(id,'localTerminalInfo')"
											@visible-change="(isVisible)=>getRealTimeVpc(isVisible,'localTerminalInfo')"
											:placeholder="$t('privateNetInstance.chooseVPC')">
											<el-option v-for="(vpc, index) in localTerminalInfo.vpcList"
												:key="index"
												:label="vpc.showName"
												:value="vpc.vpcId">
											</el-option>
										</el-select>
										<el-button type="text" @click="jumpToVpcList">
											{{ $t('privateNetInstance.createPrivateNetwork') }}
										</el-button>
										<span slot="hint" v-if="localTerminalInfo.vpcId && localTerminalInfo.vpcCidr">{{$t('privateNetInstance.privateNetCidr',[localTerminalInfo.vpcCidr])}}</span>
										<span slot="hint" v-if="localTerminalInfo.vpcId && localTerminalInfo.vpcIpv6Cidr">{{$t('privateNetInstance.privateNetIpv6Cidr',[localTerminalInfo.vpcIpv6Cidr])}}</span>
										<p v-if="localTerminalInfo.ipv4CidrIsOverlap"
											class="jc-form-item-help-error">
											{{$t("peering.help.ipv4CidrIsOverlap")}}</p>
									</el-form-item>
								</el-form>
							</div>
							<div class="jc-page-card">
								<div class="jc-page-card-header">
									<h3 class="jc-page-card-title">{{$t("peering.text.oppositeTerminalInfo")}}</h3>
								</div>
								<el-form class="jc-form cps-create-form" label-width="130px"
									ref="oppositeTerminalInfoForm"
									id="oppositeTerminalInfoForm"
									:model="oppositeTerminalInfo" :rules="rules">
									<!-- 对端账号类型 -->
									<el-form-item :label="$t('peering.text.oppositeAccountType') | withColon">
										<el-radio-group v-model="oppositeTerminalInfo.accountType"
											@change="accountTypeChange">
										    <el-radio v-for="(item) in accountTypes" :key="item.label" :label="item.value" >{{item.label}}</el-radio>
										</el-radio-group>
										<el-tooltip effect="dark" placement="right" class="ml10">
								          	<div slot="content" class="my-create-tip">
								            	{{$t('peering.tooltip.accountType')}}
								          	</div>
								          	<a><i class="jc-icon-question"></i></a>
								        </el-tooltip>
									</el-form-item>
									<!--对端账号-->
									<el-form-item
										v-show="oppositeTerminalInfo.accountType === 'different'"
										:label="$t('peering.text.oppositeAccountNumber') | withColon"
										prop="oppositeAccountNumber"
										:show-message="false" required
										ref="oppositeAccountNumber">
										<el-input
											:placeholder="$t('peering.placeholder.oppositeAccountNumber')"
											v-model="oppositeTerminalInfo.oppositeAccountNumber"
											></el-input>
										<el-tooltip effect="dark" placement="right" class="ml10">
								          	<div slot="content" class="my-create-tip">
								            	{{$t('peering.tooltip.oppositeAccountNumber')}}
								          	</div>
								          	<a><i class="jc-icon-question"></i></a>
								        </el-tooltip>
										<p v-if="ruleFormTag.oppositeAccountNumber === 'empty' "
											class="jc-form-item-help-error">
											{{$t('privateNetInstance.empty')}}</p>
									</el-form-item>
									<!-- 对端地域 -->
									<el-form-item :label="$t('peering.text.oppositeRegion') | withColon">
										<el-select v-model="oppositeTerminalInfo.region"
											@change="(val) => regionChange(val, 'oppositeTerminalInfo')">
											<el-option v-for="(regionName,region,index) in regions"
												:key="index"
												:label="regionName"
												:value="region">
											</el-option>
										</el-select>
									</el-form-item>
									<!-- 对端私有网络 -->
									<el-form-item
										v-show="oppositeTerminalInfo.accountType === 'same'"
										:label="$t('peering.text.oppositeVpc')| withColon"
										:show-message="false"
										class="net-select"
										required
										prop="vpcId" ref="vpcId">
										<el-select v-model="oppositeTerminalInfo.vpcId" class="select-vpc"
											:loading="oppositeTerminalInfo.vpcLoading"
											@change="(id)=>vpcChange(id,'oppositeTerminalInfo')"
											@visible-change="(isVisible)=>getRealTimeVpc(isVisible,'oppositeTerminalInfo')"
											:placeholder="$t('peering.text.chooseOppositeVpc')">
											<el-option v-for="(vpc, index) in oppositeTerminalInfo.vpcList"
												:key="index"
												:label="vpc.showName"
												:value="vpc.vpcId">
											</el-option>
										</el-select>
										<el-button type="text" @click="jumpToVpcList">
											{{ $t('privateNetInstance.createPrivateNetwork') }}
										</el-button>
										<span slot="hint" v-if="oppositeTerminalInfo.vpcId && oppositeTerminalInfo.vpcCidr">{{$t('privateNetInstance.privateNetCidr',[oppositeTerminalInfo.vpcCidr])}}</span>
										<span slot="hint" v-if="oppositeTerminalInfo.vpcId && oppositeTerminalInfo.vpcIpv6Cidr">{{$t('privateNetInstance.privateNetIpv6Cidr',[oppositeTerminalInfo.vpcIpv6Cidr])}}</span>
										<p v-if="oppositeTerminalInfo.ipv4CidrIsOverlap"
											class="jc-form-item-help-error">
											{{$t("peering.help.ipv4CidrIsOverlap")}}</p>
									</el-form-item>
									<!-- 对端私有网络 -->
									<el-form-item
										v-show="oppositeTerminalInfo.accountType === 'different'"
										:label="$t('peering.text.oppositeVpc') | withColon"
										prop="oppositeVpcId"
										:show-message="false" required
										ref="oppositeVpcId">
										<el-input
											v-model="oppositeTerminalInfo.oppositeVpcId"
											:placeholder="$t('peering.placeholder.oppositeVpcId')"></el-input>
									</el-form-item>
								</el-form>
							</div>
							<!-- 带宽 -->
							<div class="jc-page-card" id="bandwidth">
								<div class="jc-page-card-header">
									<h3 class="jc-page-card-title">{{$t("privateNetInstance.bandwidth")}}</h3>
								</div>
								<el-form
									class="jc-form cps-create-form"
									label-width="130px"
									ref="networkInfo">
									<el-form-item
										v-if="!isSameRegion"
										:label="$t('create.text.banCalModel') | withColon">
										<el-radio-group v-model="selectedPaymentType">
											<el-radio-button
												v-for="(item, key) in bandwidthPaymentTypes"
												:key="item.key"
												:label="item.value">
												{{item.label}}
											</el-radio-button>
										</el-radio-group>
										<el-tooltip class="ml10" effect="dark" placement="right"
											content="Right Top">
											<div slot="content" class="my-os-disk-tip">
												{{$t('peering.tooltip.bandWidth')}}
											</div>
											<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
									</el-form-item>
									<el-form-item
										v-if="!isSameRegion"
										:label="$t('create.text.bandLimit') | withColon">
										<div class="jc-form-item-inline">
											<el-slider v-model="tmpMaxBandwidth" show-input
												@change="calSelectedMaxBandwidth" :max="maxBandwidth"
												:debounce="0" :min="minBandwidth" class="jc-slider-custom"
												:marks="marks">
											</el-slider>
										</div>
									</el-form-item>
									<el-form-item
										v-if="isSameRegion"
										:label="$t('create.text.bandLimit') | withColon">
										{{$t('peering.text.noLimit')}}
									</el-form-item>
								</el-form>
							</div>
						</div>
					</div>

					<!-------- 已选配置 ---------->
					<div id="selected" class="jc-form-create-selected">
						<h3 class="selected-title">
							{{$t('create.text.selectedConfig')}}</h3>
						<el-form label-width="100px" class="jc-datashow-list">
							<section class="selected-configure" style="width: 245px;">
								<!--本端地域-->
								<el-form-item :label="$t('peering.text.localRegion')">
									<p v-if="!regions[localTerminalInfo.region]">{{regions[localTerminalInfo.region] | maybeEmpty}}</p>
                                    <el-tooltip v-else effect="dark" placement="right" :content="regions[localTerminalInfo.region]">
                                        <p class="text-overflow-ellipsis">{{regions[localTerminalInfo.region]}}</p>
                                    </el-tooltip>
								</el-form-item>
								<!--本端私有网络-->
								<el-form-item :label="$t('peering.text.localVpc')">
                                    <p v-if="!localTerminalInfo.vpcName">{{localTerminalInfo.vpcName | maybeEmpty}}</p>
                                    <el-tooltip v-else effect="dark" placement="right" :content="`${localTerminalInfo.vpcName}`">
                                        <p class="text-overflow-ellipsis">{{`${localTerminalInfo.vpcName}`}}</p>
                                    </el-tooltip>
									<!-- @TODO 看是否需要展示vpcId <p v-if="!localTerminalInfo.vpcId && !localTerminalInfo.vpcName">{{localTerminalInfo.vpcId | maybeEmpty}}</p>
                                    <el-tooltip v-else effect="dark" placement="right" :content="`${localTerminalInfo.vpcName}(${localTerminalInfo.vpcId})`">
                                        <p class="text-overflow-ellipsis">{{`${localTerminalInfo.vpcName}(${localTerminalInfo.vpcId})`}}</p>
                                    </el-tooltip> -->
								</el-form-item>
								<!--对端账号-->
								<el-form-item
									v-show="oppositeTerminalInfo.accountType === 'different'"
									:label="$t('peering.text.oppositeAccountNumber')">
                                        <p v-if="!oppositeTerminalInfo.oppositeAccountNumber" class="text-overflow-ellipsis">{{oppositeTerminalInfo.oppositeAccountNumber | maybeEmpty}}</p>
                                        <el-tooltip v-else effect="dark" placement="right" :content="oppositeTerminalInfo.oppositeAccountNumber">
                                            <p class="text-overflow-ellipsis">{{oppositeTerminalInfo.oppositeAccountNumber}}</p>
                                        </el-tooltip>
								</el-form-item>
								<!--对端地域-->
								<el-form-item :label="$t('peering.text.oppositeRegion')">
									<p v-if="!regions[oppositeTerminalInfo.region]">{{regions[oppositeTerminalInfo.region] | maybeEmpty}}</p>
                                    <el-tooltip v-else effect="dark" placement="right" :content="regions[oppositeTerminalInfo.region]">
                                        <p class="text-overflow-ellipsis">{{regions[oppositeTerminalInfo.region]}}</p>
                                    </el-tooltip>
								</el-form-item>
								<!--对端私有网络-->
								<el-form-item :label="$t('peering.text.oppositeVpc')">
                                    <!-- 为空是展示 -->
                                    <div v-if="!oppositeTerminalInfo.vpcName && !oppositeTerminalInfo.oppositeVpcId">
                                        <p v-show="oppositeTerminalInfo.accountType === 'same'">{{oppositeTerminalInfo.vpcName | maybeEmpty}}</p>
                                        <p v-show="oppositeTerminalInfo.accountType === 'different'" :title="oppositeTerminalInfo.oppositeVpcId">{{oppositeTerminalInfo.oppositeVpcId | maybeEmpty}}</p>
                                    </div>
                                    <el-tooltip v-else effect="dark" placement="right">
                                        <div>
                                            <p v-show="oppositeTerminalInfo.accountType === 'same'" class="text-overflow-ellipsis">{{`${oppositeTerminalInfo.vpcName}` | maybeEmpty}}</p>
                                            <!-- <p v-show="oppositeTerminalInfo.accountType === 'same'" class="text-overflow-ellipsis">{{`${oppositeTerminalInfo.vpcName}(${oppositeTerminalInfo.vpcId})` | maybeEmpty}}</p> -->
                                            <p v-show="oppositeTerminalInfo.accountType === 'different'" :title="oppositeTerminalInfo.oppositeVpcId" class="text-overflow-ellipsis">{{oppositeTerminalInfo.oppositeVpcId | maybeEmpty}}</p>
                                        </div>
                                        <div slot="content">
                                            <p v-show="oppositeTerminalInfo.accountType === 'same'">{{`${oppositeTerminalInfo.vpcName}` | maybeEmpty}}</p>
                                            <!-- @TODO 看是否需要展示vpcId <p v-show="oppositeTerminalInfo.accountType === 'same'">{{`${oppositeTerminalInfo.vpcName}(${oppositeTerminalInfo.vpcId})` | maybeEmpty}}</p> -->
                                            <p v-show="oppositeTerminalInfo.accountType === 'different'" :title="oppositeTerminalInfo.oppositeVpcId">{{oppositeTerminalInfo.oppositeVpcId | maybeEmpty}}</p>
                                        </div>
                                    </el-tooltip>
								</el-form-item>
								<!--带宽-->
								<el-form-item :label="$t('privateNetInstance.bandwidth')">
                                    <p v-show="isSameRegion">{{$t('peering.text.noLimit')}}</p>
                                    <p v-show="!isSameRegion">{{$t('peering.text.byBandwidth',[selectedMaxBandwidth])}}</p>
								</el-form-item>
								<!--购买数量-->
								<el-form-item :label="$t('create.text.buyNum')">
									<p>{{selectedHostNumber}}</p>
								</el-form-item>
							</section>
							<!--费用-->
							<section class="selected-cost">
								<h3 class="selected-cost-title">
								{{$t('create.text.cost')}}</h3>
								<!--对等连接-->
							  	<el-form-item
							  		class="mt10"
							  		:label="$t('peering.text.connection')">
									<p class="form-item-nopadding">
                                     <span class="price highlight-font-color" style="font-size: 21px;" v-show="!isSameRegion">
                                        {{ $t('create.text.feePerHour', [peeringPriceOneHour])}}
                                    </span>
									  	<span class="price highlight-font-color"
									  		v-show="isSameRegion">{{$t('peering.text.free')}}</span>
									</p>
									<p
										v-show="!isSameRegion"
										class="month-total-position like-form-help-item">
										<span>{{ $t('peering.text.monthPay', [peeringPriceOneMonth]) }}</span>
										<span class="none">{{configurationCalTotalPrice.peeringPriceOneHour}}</span>
									</p>
							  	</el-form-item>
                    <!-- totalDiscount !== '0.00' 是为了修复价格展示统一转换后，导致其值非数值型0，导致没有折扣也展示了该优惠dom -->
                  <save-price
                    v-if="totalDiscount && !isSameRegion && totalDiscount !== '0.00'"
                    :totalDiscount="favorablePricePerHour"
                    :originPrice="totalOriginalPrice"
                  ></save-price>
								<el-button type="primary" size="large"
									:disabled="!isCertification
									|| !quotaIsEnough || oppositeTerminalInfo.ipv4CidrIsOverlap || localTerminalInfo.ipv4CidrIsOverlap"
									class="my-buy-btn mt10" @click="buy">{{isBuyTag}}
								</el-button>
								<p v-if="!isCertification" class="red mt10">
									{{$t('create.help.noCertification')}}
									<a :href="Config.REALNAME_URL">
										{{$t('create.help.goCertificate')}}</a>
								</p>
								<p v-else-if="!quotaIsEnough" class="red mt10">
									{{$t('peering.text.exceedQuota')}}{{$t('create.help.contact')}}
									<a :href="Config.WORK_URL" target="_blank">{{$t('create.tooltip.ticket')}}</a>
								</p>
								<p v-else-if="oppositeTerminalInfo.accountType === 'different'" class="red mt10">
									{{ $t('peering.help.acceptConnect', [nextDay]) }}
								</p>
							</section>
						</el-form>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>


<script>
import { NetworkTypeConstant,CreateTypeConstant, ServiceCodeConstant, AccountTypes,BillingTypesConstant,BillingOperateTypeConstant} from '@/common/Constants';
import {checkIpv4CidrIsOverlapApi,getPeeringQuotaApi,getPeerRegionsApi,addPeerConnApi} from "@/api/peering/create/actions";
import {getVpcsListApi} from "@/api/privateNetwork/list/actions";
import ifCertification from '@/mixins/ifCertification';
import initSelectedPotision from '@/mixins/initSelectedPotision';
import locateToErrorElement from '@/mixins/locateToErrorElement';
import {changeTwoDecimal,compose,deepCopy,dispatch,isTargetType, mulDecimals, subDecimals } from '@/common/tool';
import { getYMD } from '@/common/dataHelper';
import SavePrice from '@/components/common/SavePrice';
const OneDay = 24 * 3600 * 1000;
export default {
	name: 'PeeringCreate',
	components: {
    SavePrice
	},
	mixins:[ifCertification,initSelectedPotision,locateToErrorElement],
	data() {
		const validateName = (rule, value, callback) => {
			const reg = new RegExp('^[a-zA-Z\\\u4e00-\\\u9fa5]([0-9a-zA-Z\\\u4e00-\\\u9fa5-_.:{}]{1,127})$');
			if (!value) {
				this.ruleFormTag.name = 'empty';
				callback(new Error());
			} else {
				const result = reg.test(value);
				if (!result) {
					this.ruleFormTag.name = 'error';
					callback(new Error());
				} else {
					this.ruleFormTag.name = '';
					callback();
				}
			}
		};
		const validateOppositeAccountNumber = (rule, value, callback) => {
			if (!value) {
				this.ruleFormTag.oppositeAccountNumber = 'empty';
				callback(new Error());
			}
			callback();
		};
		const validateOppositeVpcId = (rule, value, callback) => {
			if (!value) {
				callback(new Error(this.$t('privateNetInstance.empty')));
			} else {
				this.ruleFormTag.oppositeVpcId = '';
				callback();
			}

		};
		this.accountTypes = AccountTypes;
		return {
			userQuotas: {}, // 当前用户的地域对等连接配额
			localTerminalInfo: {
				name: '',
				region: '',
				vpcLoading: true,
				vpcId: '',
				ipv4CidrIsOverlap: false,
				vpcName: '',
				vpcCidr: '',
				vpcIpv6Cidr: '',
				vpcList: [],
			},
			oppositeTerminalInfo: {
				accountType: 'same',
				oppositeAccountNumber: '',
				region: '',
				vpcLoading: true,
				vpcId: '',
				ipv4CidrIsOverlap: false,
				vpcName: '',
				vpcCidr: '',
				vpcIpv6Cidr: '',
				vpcList: [],
				oppositeVpcId: ''
			},
			quotaNumber: 1,
			chargeUnit: 3, // 计费时长单位 1:小时 2:天 3:月 4:年,
			chargeDuration: 1, //计费时长,

			// 带宽计费模式
			selectedPaymentType: 1,
			bandwidthPaymentTypes: [
			],
			tmpMaxBandwidth: 1,
			selectedMaxBandwidth: 1,
			minBandwidth:1,
			maxBandwidth:10240,
			marks: {1:'1Mbps', 10240:'10240Mbps'},
			// 购买数量
			selectedHostNumber: 1,
			maxHostNumber: 5,
			// 实名认证
			isBuyTag: this.$t('create.text.buyNow'),
			// 按配置价格
			peeringPriceOneHour: 0,
			peeringPriceOneMonth: 0,
			// 地域名称对应
			regions: {},
			ruleFormTag: {
				name: '',
				oppositeAccountNumber: '',
				oppositeVpcId: ''
			},
			localTerminalInfoRules: {
				name: [
					{ required: true, validator: validateName, trigger: 'blur' }
				],
				vpcId: [
					{ required: true, validator: validateOppositeVpcId, trigger: 'blur' }
				],
			},
			rules: {

				vpcId:  [
					{ validator: validateOppositeVpcId, trigger: 'blur' }
				],

				oppositeAccountNumber: [
					{  validator: validateOppositeAccountNumber, trigger: 'blur' }
				],

				oppositeVpcId: [
					{ validator: validateOppositeVpcId, trigger: 'blur' }
				]
			},
			nextDay: '',
			nextDayTimer: null,
			nextDayTimerInterval: 1000, //接受请求提示语间隔刷新时间
      totalDiscount: 0,
      favorablePricePerHour: 0,
      totalOriginalPrice: 0,
		};
	},
	computed: {
        /**
         * 计算总价的长度，控制选配费用的展示
         */
        peeringPriceOneHourLength7 () {
            return this.peeringPriceOneHour?.length > 7
        },
		/**
		* 费用计算
		*/
		configurationCalTotalPrice() {
			return this.configurationsCalculateTotalPrice();
		},
		ServiceCodeConstant: () => ServiceCodeConstant,
		BillingOperateTypeConstant: () => BillingOperateTypeConstant,
		/**
		* @return {boolean}
		*/
		quotaIsEnough() {


			let	isEnough = this.selectedHostNumber <= this.quotaNumber;

			return isEnough
		},

		/** 是否同地域
		* @return {boolean}
		*/
		isSameRegion() {
			return this.localTerminalInfo.region === this.oppositeTerminalInfo.region
		},
        /**
         * @description 本端地域下拉过滤地域，只要当前的地域
         */
        peerRegions () {
            const region = this.$route.query?.region
            if (region && this.regions?.[this.$route.query?.region]) {
                return {
                    [region]: this.regions?.[this.$route.query.region]
                }
            }
            return this.regions
        },
	},
	watch: {

	},
	async created() {
		this.initBandwidthPaymentTypes();
		this.setNextDay();
		await this.getRegion();
		this.getAccountQuota();
	},
	destroyed() {
		clearTimeout(this.nextDayTimer);
	},
	methods: {

		/**
		 * 地域切换时重置数据
		 * 切换时私有网络相关数据初始化
		 * @param {{region: string, tag: string}}
		 * */
		regionChange(region, tag) {
			this.getAccountQuota();
			this.resetCurrentTerminalInfoVpcInfo(region, tag);
		},
		/**
		 * 重置当前端网络信息
		 * @param {{region: string, tag: string}}
		 * */
		resetCurrentTerminalInfoVpcInfo(region, tag) {
			this[tag].region = region;
			this[tag].vpcLoading = true;
			this[tag].vpcName = '';
			this[tag].vpcId = '';
			this[tag].vpcName = '';
			this[tag].vpcCidr = '';
			this[tag].vpcIpv6Cidr = '';
			this[tag].vpcList = [];
		},
		/*
		*  当前页面可以跳转其它页面创建vpc
		*  当创建完返回该页面时
		*  下拉操作后确保为最新的数据
		* */
		getRealTimeVpc(isVisible,tag) {
			if (isVisible) {
				this.getVpcCount(tag);
			}
		},

		jumpToVpcList() {
			const { href } = this.$router.resolve({
				name: 'PrivateNetworkList'
			});
			window.open(href, '_blank');
		},

		// 获取选中当前vpc
		vpcChange(id,tag) {
			if (id) {
				this.getSelectVpcName(id,tag);
				this.getSelectVpcCidr(id,tag);
				this.validateIpv4CidrIsOverlap(id,tag);
			}
		},

		// 获取选中vpc名称
		getSelectVpcName(vpcId,tag) {
			this[tag].vpcList.forEach((vpc) => {
				if (vpc.vpcId === vpcId) {
					this[tag].vpcName = vpc.name;
				}
			});
		},

		// 获取选中vpc cidr及ipv6 cidr
		getSelectVpcCidr(vpcId,tag) {
			this[tag].vpcList.forEach((vpc) => {
				if (vpc.vpcId === vpcId) {
					this[tag].vpcCidr = vpc.cidr;
					this[tag].vpcIpv6Cidr = vpc.ipv6Cidr;
				}
			});
		},
		// 校验本端网络及对端网络ipv4 cidr是否重叠
		validateIpv4CidrIsOverlap(vpcId,tag) {
			if (this.oppositeTerminalInfo.vpcId && this.localTerminalInfo.vpcId) {
				let params = {
					region: this.localTerminalInfo.region,
					cidr1: this.localTerminalInfo.vpcCidr,
					cidr2: this.oppositeTerminalInfo.vpcCidr
				}
				checkIpv4CidrIsOverlapApi(params).then(res => {
					this[tag].ipv4CidrIsOverlap = res.data && res.data.success;
				}).catch(err => {
					//console.log(err);
				})
			}
		},

		// 获取当前区域下vpc
		getVpcCount(tag) {
			this[tag].vpcLoading = true;
			const params = {
				region: this[tag].region,
				pageSize: 100,
			};
			getVpcsListApi(params)
			.then((res) => {
				this.setVpcList(res, tag);
			})
			.catch(async (err)=>{
		    	const { response } = err.data;
				try {
					const json = await response.json();
					this.$message.error(json.errmsg);
				} catch (ex) {
					console.log(ex);
				}
		    }).finally(() => {
		    	this[tag].vpcLoading = false;
			});
		},

		setVpcList(res,tag) {
			let vpcs = res.data.vpcs.map(vpc => ({
				vpcId: vpc.vpcId,
				showName: `${vpc.name}(${vpc.vpcId})`,
				name: vpc.name,
				cidr: vpc.cidr,
				ipv6Cidr: vpc.ipv6Cidr
			}));
			const getVpcList = dispatch(isTargetType("localTerminalInfo",() => {return vpcs.filter(item => item.vpcId !== this.oppositeTerminalInfo.vpcId)}),isTargetType("oppositeTerminalInfo",() => {return vpcs.filter(item => item.vpcId !== this.localTerminalInfo.vpcId)}));
			this[tag].vpcList = getVpcList({type: tag});
		},
		getAccountQuota() {
			const param = {
		        region: this.localTerminalInfo.region,
		    };
		    getPeeringQuotaApi(param)
		    .then((res) => {
		    	this.userQuotas = res.data;
		    	this.quotaNumber = this.userQuotas.availableQuota;
		    }).catch(async (err)=>{
		    	const { response } = err.data;
				try {
					const json = await response.json();
					this.$message.error(json.errmsg);
				} catch (ex) {
					console.log(ex);
				}
		    });

		},
		getRegion() {
			const param = {
		        networkType: NetworkTypeConstant.VPC
		    };
		    return getPeerRegionsApi(param)
		    .then((res) => {
				this.regions = res.data.regions.reduce((init, current) => {
					let region = current.region;
					init[region] = current.regionName
					return init
				}, {});
				const passedRegion = this.$route.query.region;
				this.oppositeTerminalInfo.region = this.localTerminalInfo.region = passedRegion || res.data.regions.filter((item, index) => index === 0).reduce((init, current) => current.region,'');
		    }).catch(async (err)=>{
		    	const { response } = err.data;
				try {
					const json = await response.json();
					this.$message.error(json.errmsg);
				} catch (ex) {
					console.log(ex);
				}
		    });
		},

		checkIsNeedBilling() {
			return this.localTerminalInfo.region && !this.isSameRegion
		},

		configurationsCalculateTotalPrice() {
			let isNeedBilling = this.checkIsNeedBilling();
			if (!isNeedBilling) {
				return '';
			}
			const param = {
				cmd: this.BillingOperateTypeConstant['create'],
				region: this.localTerminalInfo.region,
				internetChargeMode: BillingTypesConstant.POSTPAID_BY_DURATION,
				count: this.selectedHostNumber,
				createType: CreateTypeConstant.PEERING,
				billingType: BillingTypesConstant.POSTPAID_BY_DURATION,
				bw: this.selectedMaxBandwidth
			};

			Ajax.get('/api/price/calculateTotalPrice',param).then(res => {
        const { discountedTotalPrice, totalPrice, totalDiscount, list, totalOriginalPrice} = res?.data || {};
        console.log('shuju', totalDiscount)
        this.totalOriginalPrice = changeTwoDecimal(totalOriginalPrice);
        this.totalDiscount = changeTwoDecimal(totalDiscount);
        console.log('this.totalDiscount', this.totalDiscount)
				this.peeringPriceOneHour = changeTwoDecimal(list.length ? list[0]?.discountedPrice : '');
				this.peeringPriceOneMonth = changeTwoDecimal(list.length ? mulDecimals(mulDecimals(list[0].discountedPrice, 24), 30): '');
        this.favorablePricePerHour = totalDiscount ? changeTwoDecimal(subDecimals(totalPrice, discountedTotalPrice)) : null;
			})
			return '';
		},

		calSelectedMaxBandwidth(val) {
			this.selectedMaxBandwidth = this.tmpMaxBandwidth;
		},
		goToList() {
			this.$router.push({
				path: '/peering/list',
				query: {
					region: this.localTerminalInfo.region
				}
			});
		},
		buy() {
			let formValid = true;
			this.$refs.localTerminalInfoForm.validate((valid) => {
				formValid = valid;
			});

			if (!formValid) {
				this.locateToErrorElement("localTerminalInfoForm");
				return false;
			}

			let accountType = this.oppositeTerminalInfo.accountType;
			if (accountType === 'same') {
				this.$refs.oppositeTerminalInfoForm.validateField('vpcId', (valid) => {
					formValid = !!valid ? false : true;
				})
			} else {
				let accountNumberValid,vpcIdValid;
				this.$refs.oppositeTerminalInfoForm.validateField('oppositeAccountNumber', (valid) => {
					accountNumberValid = !!valid ? false : true;
				});
				this.$refs.oppositeTerminalInfoForm.validateField('oppositeVpcId', (valid) => {
					vpcIdValid = !!valid ? false : true;
				});
				formValid = accountNumberValid && vpcIdValid;
			}
			if (!formValid) {
				this.locateToErrorElement("oppositeTerminalInfoForm");
				return false;
			}
			this.createOrder();

		},

		setOrderParam() {
			const param = {
				clientToken: Normal.getClientToken(),
				timestamps: Normal.getClientToken(),
				orderType: 1, // 新购
				region: this.localTerminalInfo.region,
				chargeMode: 1, // 计费类型[1,2,3,4] 1:配置,2:用量,3:包年包月,4:一次性付费
				chargeDuration: this.chargeDuration, // 计费时长
				chargeUnit:  this.chargeUnit, // 计费时长单位
				quantity: this.selectedHostNumber, // 购买数量
				name: this.localTerminalInfo.name, // 名称
				senderRegion: this.localTerminalInfo.region,
				vpcIden: this.localTerminalInfo.vpcId,
				receiverAccount: this.oppositeTerminalInfo.oppositeAccountNumber,
				receiverRegion: this.oppositeTerminalInfo.region,
			};
			return param
		},

		setReceiverVpcIdenParam(param) {
			let orderParam = deepCopy(param);
			let accountType = this.oppositeTerminalInfo.accountType;
			if (accountType === 'different') {
				orderParam.receiverVpcIden = this.oppositeTerminalInfo.oppositeVpcId;
			} else {
				orderParam.receiverVpcIden = this.oppositeTerminalInfo.vpcId;
			}
			return orderParam
		},

		setBandwidthParam(param) {
			let orderParam = deepCopy(param);
			let isSameRegion = this.isSameRegion;
			// 同地域默认值特殊处理
			if (isSameRegion) {
				orderParam.bandwidth = 1000;
			} else {
				orderParam.bandwidth = this.selectedMaxBandwidth;
			}
			return orderParam
		},
		createOrder() {
			const getParam = compose(this.setBandwidthParam,this.setReceiverVpcIdenParam,this.setOrderParam);
			const param = getParam();
			addPeerConnApi(param).then((res) => {
				const orderId = res.data.tempOrderNumber;
				// 跨地域跳转订单页，同地域直接跳转列表页
				if (orderId) {
					window.location.href = `${this.Config.ORDER_URL}/confirm?buyId=${orderId}&source=1`;
				} else {
					this.goToList();
				}
			})
			.catch(async (err) => {
				const { response } = err.data;
				try {
					const json = await response.json();
					this.$message.error(json.errmsg);
				} catch (ex) {
					console.log(ex);
				}
			});
		},
		initBandwidthPaymentTypes() {
			this.bandwidthPaymentTypes = [
				{label:this.$t('peering.text.constBandWidth'),value:1,key:1},
			];
			this.selectedPaymentType = 1;
		},

		accountTypeChange(val) {
			this.resetAccountTypeData(val);
		},
		resetAccountTypeData(val) {
			this.oppositeTerminalInfo = {
				accountType: val,
				oppositeAccountNumber: '',
				region: this.oppositeTerminalInfo.region,
				vpcLoading: true,
				vpcId: '',
				ipv4CidrIsOverlap: false,
				vpcName: '',
				vpcCidr: '',
				vpcIpv6Cidr: '',
				vpcList: [],
				oppositeVpcId: ''
			};
		},
		setNextDay() {
			const Now = new Date().getTime();
			this.nextDay = getYMD(OneDay + Now);
			clearTimeout(this.nextDayTimer);
			this.nextDayTimer = setTimeout(() => {
				this.setNextDay();
			}, this.nextDayTimerInterval)
		},
	}
};
</script>

<style lang="scss">
	@import '~@/assets/scss/createCommon';
	@import '~@/assets/scss/selectedConfigure';
	@import '~@/assets/scss/sliderCommon';
	@import 'style';
</style>



// WEBPACK FOOTER //
// src/views/peering/create/Create.vue